import { BoardBackground } from 'app/scripts/models/BoardBackground';
import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers.coffee';

class BoardBackgroundList extends CollectionWithHelpers {
  static initClass() {
    this.prototype.model = BoardBackground;
  }
  url() {
    return `/1/member/${this.member.id}/boardBackgrounds`;
  }

  // @ts-ignore
  initialize(list, { member }) {
    this.member = member;
  }
}
BoardBackgroundList.initClass();

export { BoardBackgroundList };
